<section class="w3l-form-25">
    <div class="header">

        <h1>Treatment Group Master Data.</h1>
        <p>Enter Treatment Group Details Master Data below to stay updated </p>

    </div>

</section>
<div id="w3l-appointment">
    <section class="appointment-section section-gap">

        <div class="wrapper">
            <div class="d-grid doctor-appointment">
                <div class="appointment-form">
                    <form action="#" method="post">
                        <div class="fields-grid">
                            <div class="styled-input">
                                <label>Treatment Group Code</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="TreatmentGroupSearch()"></span>
                                    <input type="text" name="tgcode" placeholder="Group Code" style="width: 15%;" [(ngModel)]="tgcode" (change)=" retriveTreatmentGroupHD()">

                                </div>
                            </div>
                            <div>
                                <label>Treatment Group Description</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-bookmark" aria-hidden="true"></span>
                                    <input type="text" name="tgname" placeholder="Treatment Group Description" style="width: 50%; " required="" [(ngModel)]="tgname">
                                </div>
                            </div>
                            
                            <!-- <div>
                                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;width: 80% ;">Home Drugs</label>
                            </div> -->
                            <table>
                                <thead>
                                    <tr>
                                        <th style="width: 15%; height: 13%;">Item Code</th>
                                        <th style="width: 22%; height: 15%;">Item Name</th>
                                        <th style="width: 15%;height: 10%;">Dose</th>
                                        <th style="width: 15%;height: 15%;">Unit</th>
                                        <th style="width: 20%;height: 15%;">Frequency</th>
                                        <th style="width: 20%;height: 15%;">Notes</th>
                                        <!-- <th style="width: 20%;height: 15%;">Notes</th> -->
                                        <th style="width: 12%;height: 20%;">Select</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let DrugP of DrugGroup; let i = index" style="height: 50%; width: 80%; align-items: center;">
                                        <td data-column="tgdetitcode" style="height: 20%;">{{DrugP.tgdetitcode}}</td>
                                        <td data-column="tgdetitname" style="height: 15%;">{{DrugP.tgdetitname}}</td>
                                        <td data-column="tgdetdose" style="height: 20%;">{{DrugP.tgdetdose}}</td>
                                        <td data-column="tgdetqty" style="height: 20%;">{{unName[i]}} </td>
                                        <td data-column="tgdetrote" style="height: 20%;">{{DrugP.tgdetrote}}</td>
                                        <td data-column="tgdetduration" style="height: 20%;">{{DrugP.tgdetduration}}</td>
                                        <td style="height: 15%;">
                                            <Button style="width: 100%;" (click)="TreatmentGroupDetEdit(DrugP)">Select</Button>
                                        </td>
                                    </tr>
                                    <tr style="height: 50%; width: 100%; align-items: center;">
                                        <td style="height:50px ; width: 100%;"><span class="fa fa-search" aria-hidden="true" style="color: var(--theme-color); cursor: grab; width:20%; height: 40px; " (click)="openDialog()"></span>
                                            <input  type="text" name="tgdetitcode" required="" placeholder="Code" style="width : 80%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" [(ngModel)]="tgdetitcode" (change)="retriveItems()" >
                                        </td>
                                        <td style="height:50px ; width: 100%;"><input style="width : 100%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" type="text" name="tgdetitname" required="" placeholder="Name" [(ngModel)]="tgdetitname"></td>
                                        <td style="height:50px ; width: 100%;"><input style="width : 100%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" type="text" name="tgdetdose" required="" placeholder="Dose" [(ngModel)]="tgdetdose"></td>

                                        <td style="height:50px ; width: 100%;">
                                                   <select id="department" name="units" required="" style="width: 100%;height: 95%; background-color: white;" [(ngModel)]="tgdetqty" [value]="tgdetqty">
                                                   <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
                                                   </select>
                                      </td>
                                        
                                        <td style="height:50px ; width: 100%;"><input style="width : 100%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" type="text" name="tgdetrote" required="" placeholder="Frequency" [(ngModel)]="tgdetrote"></td>
                                        <td style="height:50px ; width: 100%;"><input style="width : 100%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" type="text" name="tgdetduration" required="" placeholder="Notes" [(ngModel)]="tgdetduration"></td>
                                        <!-- <td style="height:50px ; width: 100%;"><input style="width : 80%; height: 100%;background-color: white;font-size: small;border-radius: 5px;" type="text" name="tgdetnotes" required="" placeholder="Notes" [(ngModel)]="tgdetnotes"></td> -->
                                        <td style="height:50px ; width: 100%;">
                                            <button class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%; width:50%" (click)="submitMed()"></button>
                                            <button class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;width:50%" (click)="mesgDeleteDet()"></button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>


                            <!-- <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">Requested Labs </label>
                          <table>
                              <thead>
                                  <tr>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 200px;">Lab code </th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;">Lab Name</th>
                                      <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;">Select</th>
                                  </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let Lab of labList; let i = index" style="height: 50%;">
                                  <td data-column="labcode" style="height: 10%;"></td>
                                  <td data-column="labname"style="height: 15%;"></td>
                                  <td data-column="Patient Name"style="height: 15%;"></td>
                                </tr>

                 <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">
                  <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openLabDialog()"></span>
                <input type="text" name="labcode" required="" placeholder="Code" style="width: 8%;background-color: white;font-size: small;" [(ngModel)]="labcode" >
                <input type="text" name="labname" required="" placeholder="Name" style="width: 16%;background-color: white;font-size: small;" [(ngModel)]="labname">
                <button  class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 4.5%;height: 100%;border-radius: 10%;" (click)="submitLabs()"></button>
                <button  class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 4.5%;height: 100%;border-radius: 10%;" (click)="mesgDelete()"></button>
              </div>
                  </tbody>
                </table> -->

                            <br>
                            <br>
                            <div class="buttons" style="width: 100%">
                                <button type="button" class="theme-button btn" name="submit" style="width: 25%;" (click)="submitTreatmentGroup()">Submit</button>
                                <button type="button" class="theme-button btn" name="Delete" style="width: 25%;" (click)="mesgDelete()">Delete</button>
                                <button type="button" class="theme-button btn" name="New" style="width: 25%;" (click)="NewData()">New</button>
                                <a href="Home" style="width: 25%">
                                    <button type="button" class="theme-button btn" name="Back" style="width: 100%;">Home</button>
                                </a>
                            </div>
                            <div class="clear"> </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </section>
</div>
